// extracted by mini-css-extract-plugin
module.exports = {"frontpageCard":"FrontPageCard_frontpageCard__U_08C"};